
import { Component, Vue, Watch } from "vue-property-decorator";
import request from "@/lib/request/request";
import Breadcrumb from "@/components/layout/breadcrumb.vue";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import * as echarts from "echarts";

import Model from "@/lib/model/model";

export class Param extends Model {
  companyId = "";
  examId = "";
}
export class EcData extends Model {
  key = "";
  value = "";
  number = 0;
  valueBak = ""; //两位小数
}
@Component({
  components: { Breadcrumb }
})
export default class QuestionPaperVue extends Vue {
  $refs!: {
    echarts1: HTMLCanvasElement;
    echarts2: HTMLCanvasElement;
    echarts3: HTMLCanvasElement;
  };

  companyId = "";
  examId = "";
  ec: EcData[][] = [[new EcData()]];
  show = false;
  //饼图用色
  colorList = [
    "#8751FDFF",
    "#33DFE4FF",
    "#FDC151FF",
    "#33DFE4",
    "#FDC151",
    "#4CDE99",
    "#8851FD",
    "#33B1FF",
    "#FF9245",
    "#FD5151"
  ];
  //Ec饼状图配置
  optionPie = {
    tooltip: {
      trigger: "item",
      formatter: "{b}：{c}人({d}%)"
    },
    series: [
      {
        minAngle: 1,
        name: "考察维度权重",
        type: "pie",
        clockwise: false, //是否顺时针
        color: this.colorList,
        radius: ["40%", "65%"],
        label: {
          show: true,
          fontSize: 12,
          lineHeight: 14,
          color: "#8590A6",
          formatter: "{b}" + "\n" + "{c}人({d}%)",
          position: "left"
        },
        itemStyle: { borderWidth: 1, borderColor: "#FFFFFF" },
        emphasis: {
          scaleSize: 2,
          focus: "self",
          //聚焦态
          label: {
            show: true,
            fontSize: "12px",
            fontWeight: "bold"
          }
        },
        labelLine: {
          show: false,
          length: 15, //两段线 控制文字位置
          length2: 0
        },
        data: [
          //   { value: 200, name: "A权重占比" },
          //   { value: 400, name: "B权重占比" },
          //   { value: 100, name: "C权重占比" },
          //   { value: 484, name: "D权重占比" },
          //   { value: 300, name: "E权重占比" },
          //   { value: 300, name: "F权重占比" }
        ]
      }
    ]
  };
  YJList: any = [];
  countList: string[] = [];
  NFS = "";
  loading = false; //无线滚动
  noMore = false;
  page = 1;
  pageSize = 20;
  get disabled() {
    return this.loading || this.noMore;
  }

  mounted() {
    const param: any = this.$route?.query; //入参
    this.companyId = param.companyId ?? "";
    this.examId = param.examId ?? "";
    //数值数据
    this.sendRequest("/aiExam/fsk/questionnaireCount", {
      companyId: this.companyId,
      examId: this.examId
    }).then(
      (res: any) => {
        this.ec = res.answerList;
        this.countList = String(res.count).split(""); //总卷数
        this.$nextTick(() => {
          this.setEchart();
          const t =
            Number(this.ec[1][0].valueBak.slice(0, -1)) -
            Number(this.ec[1][2].valueBak.slice(0, -1));
          t.toFixed(2);
          this.NFS = String(t) + "%";
        });
      },
      () => {
        //
      }
    );
    this.load();
  }
  load() {
    this.loading = true;
    //其他意见
    this.sendRequest("/aiExam/fsk/questionnaireMessageList", {
      companyId: this.companyId,
      examId: this.examId,
      page: this.page,
      pageSize: this.pageSize
    }).then(
      (res: any) => {
        this.YJList.push(...res.list);
        this.page++;
        if (res.list.length < this.pageSize) {
          this.noMore = true;
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }
  setEchart() {
    const optionPie1 = JSON.parse(JSON.stringify(this.optionPie));
    const optionPie2 = JSON.parse(JSON.stringify(this.optionPie));
    const optionPie3 = JSON.parse(JSON.stringify(this.optionPie));
    optionPie1.series[0].data = [];
    optionPie2.series[0].data = [];
    optionPie3.series[0].data = [];
    // this.ec[1][2].number = 3

    this.ec[0].forEach((d: any) => {
      optionPie1.series[0].data.push({ value: d.number, name: d.key });
    });
    this.ec[1].forEach((d: any) => {
      optionPie2.series[0].data.push({ value: d.number, name: d.key });
    });
    this.ec[2].forEach((d: any) => {
      optionPie3.series[0].data.push({ value: d.number, name: d.key });
    });
    //饼图
    const echarts1 = echarts.init(this.$refs.echarts1);
    const echarts2 = echarts.init(this.$refs.echarts2);
    const echarts3 = echarts.init(this.$refs.echarts3);
    echarts1.setOption(optionPie1);
    echarts2.setOption(optionPie2);
    echarts3.setOption(optionPie3);
  }

  showOption() {
    this.show = true;
  }

  close() {
    this.show = false;
  }

  //请求接口统一处理
  sendRequest(url: any, params = {}, method = "post") {
    return new Promise(function(resolve, reject) {
      request[method](url, params).then(
        (resp: { data: any; code: any; message: any }) => {
          if (resp.data.code === 0) {
            resolve(resp.data.data);
          } else {
            reject(resp.data.message);
          }
        }
      );
    }).catch(e => {
      console.log(e);
    });
  }
}
